<template>
    <el-scrollbar class="literacy-ranking-detail">
        <div class="detail-box">
            <div class="detail-box_header">态度考核</div>

            <div class="detail-box_operate">
                <div class="operate-filter">
                    <div class="operate-filter_label">选择学生:</div>

                    <el-select v-model="s_id" placeholder="请选择" @change="handleStudentChange">
                        <el-option v-for="item in studentList" :key="item.s_id" :label="item.s_name" :value="item.s_id"> </el-option>
                    </el-select>
                </div>

                <el-button type="primary" @click="$router.back()">返回</el-button>
            </div>

            <div class="detail-box_content">
                <div class="attitude-item" :style="{ 'background-color': item.color }" v-for="item in detailOptions" :key="item.key">
                    <div class="attitude-item_top">
                        <div class="top-label">{{ item.label }}</div>

                        <img :src="item.icon" alt="" />
                    </div>

                    <div class="attitude-item_bottom">
                        <template v-if="item.format === 'time'">{{ formatTime(attitudeData[item.key]) }}</template>

                        <template v-else>{{ attitudeData[item.key] }}</template>
                        <!-- {{ attitudeData[item.key] }} -->
                    </div>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
export default {
    name: "LiteracyRankingDetail",
    data() {
        return {
            studentList: [],
            s_id: Number(this.$route.query.s_id),
            attitudeData: {
                video_view_num: 0, // 视频观看次数
                video_view_time: 0, // 视频观看时长(秒)
                courseware_view_num: 0, // 课件观看次数
                courseware_view_time: 0, // 课件观看时长(秒)
                checkin_num: 0, // 签到次数
                vote_num: 0, // 投票次数
                discuss_num: 0, // 讨论次数
                rapid_answer_num: 0, // 抢答次数
                my_score: 0, // 我的分数
                max_score: 0, // 班级最高分
                min_score: 0, // 班级最低分
                avg_score: 0, // 班级平均分
                class_exercise_num: 0, // 随堂练习次数
            },
            detailOptions: [
                { key: "video_view_num", label: "视频观看次数", color: "#F1F5FE", icon: require("@/assets/images/video-play-count.png") },
                {
                    key: "video_view_time",
                    label: "视频观看时长",
                    color: "#ECF9FF",
                    icon: require("@/assets/images/video-play-time.png"),
                    format: "time",
                },
                {
                    key: "courseware_view_num",
                    label: "课件观看次数",
                    color: "#FFF6ED",
                    icon: require("@/assets/images/file-play-count.png"),
                },
                {
                    key: "courseware_view_time",
                    label: "课件观看时长",
                    color: "#FFEFEF",
                    icon: require("@/assets/images/file-play-time.png"),
                    format: "time",
                },
                { key: "checkin_num", label: "签到次数", color: "#E7FAFF", icon: require("@/assets/images/checkIns-count.png") },
                { key: "vote_num", label: "投票参与次数", color: "#ECF9FF", icon: require("@/assets/images/vote-count.png") },
                { key: "discuss_num", label: "讨论参与次数", color: "#FFEFEF", icon: require("@/assets/images/comment-count.png") },
                {
                    key: "rapid_answer_num",
                    label: "抢答参与次数",
                    color: "#F1F5FE",
                    icon: require("@/assets/images/quick-answer-count.png"),
                },
                {
                    key: "class_exercise_num",
                    label: "随堂练习参与次数",
                    color: "#E7FAFF",
                    icon: require("@/assets/images/train-count.png"),
                },
            ],
        };
    },
    created() {
        this.getStudentList();
        this.getLiteracyDetail();
    },
    methods: {
        getStudentList() {
            // showStudent
            const params = {
                type: "all",
                c_id: Number(this.$route.query.class_id),
                s_id: Number(this.$route.query.s_id),
            };

            this.$shttp.axiosGetBy(this.$api.showStudent, params, (res) => {
                if (res.code === 200) {
                    this.studentList = res.data;

                    // this.s_id = this.studentList[0].s_id;
                    // this.getLiteracyDetail();
                }
            });
        },

        getLiteracyDetail() {
            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                course_chapter: Number(this.$route.query.zhangIndex),
                course_node: Number(this.$route.query.jieIndex),
                s_id: this.s_id,
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_attitude_detail, params, (res) => {
                if (res.code === 200) {
                    if (res.data) this.attitudeData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleStudentChange(s_id) {
            this.s_id = s_id;

            this.getLiteracyDetail();
        },

        formatTime(seconds) {
            // 计算小时、分钟和秒
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.floor((seconds % 3600) / 60);
            let remainingSeconds = seconds % 60;

            // 格式化为两位数的字符串
            hours = String(hours).padStart(2, "0");
            minutes = String(minutes).padStart(2, "0");
            remainingSeconds = String(remainingSeconds).padStart(2, "0");

            return `${hours}:${minutes}:${remainingSeconds}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.literacy-ranking-detail {
    width: 100%;
    height: calc(100vh - 112px);
    // padding: 20px;
    box-sizing: border-box;
    background-color: #ffffff;

    ::v-deep .el-scrollbar__wrap {
        margin: 0 !important;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .detail-box {
        padding: 24px 40px;
        box-sizing: border-box;

        &_header {
            height: 24px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 800;
            font-size: 24px;
            color: #333333;
            line-height: 24px;
        }

        &_operate {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 20px;

            .operate-filter {
                display: flex;
                align-items: center;
                gap: 20px;

                &_label {
                    height: 30px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 30px;
                }

                ::v-deep .el-input__inner {
                    background-color: transparent !important;
                }
            }

            .el-button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 88px;
                height: 36px;
            }
        }

        &_content {
            margin-top: 20px;
            display: flex;
            gap: 16px;
            flex-wrap: wrap;

            .attitude-item {
                width: calc((100% - 64px) / 5);
                height: 185px;
                border-radius: 8px;
                box-sizing: border-box;
                padding: 24px;

                &_top {
                    display: flex;
                    justify-content: space-between;

                    .top-label {
                        height: 24px;
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 500;
                        font-size: 16px;
                        color: #3a4b7d;
                        line-height: 24px;
                    }

                    img {
                        transform: translateY(-14px);
                        width: 80px;
                        height: 80px;
                        object-fit: cover;
                    }
                }

                &_bottom {
                    display: flex;
                    justify-content: center;

                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: bold;
                    font-size: 32px;
                    color: #11306b;
                    line-height: 38px;
                    letter-spacing: 1px;
                }
            }
        }
    }
}
</style>
